import * as React from 'react';

import { useQuery } from '@apollo/client';

import { useProgram } from 'bundles/unified-common/contexts/EnterpriseProgramContext';
import EnterpriseAllSkillPathwaysContext from 'bundles/unified-home-common/contexts/enterprise/EnterpriseAllSkillPathwaysContext';
import EnterpriseGetAllSkillPathwaysQuery from 'bundles/unified-home-common/queries/EnterpriseGetAllSkillPathways.graphql';
import type {
  EnterpriseGetAllSkillPathwaysQuery as EnterpriseGetAllSkillPathwaysQueryType,
  EnterpriseGetAllSkillPathwaysQueryVariables,
} from 'bundles/unified-home-common/queries/__generated__/EnterpriseGetAllSkillPathways';

export const EnterpriseAllSkillPathwaysDataProvider = ({
  children,
  ssr = true,
}: React.PropsWithChildren<{ ssr?: boolean }>) => {
  const program = useProgram();
  const programId = program?.id;

  const { data, loading, error } = useQuery<
    EnterpriseGetAllSkillPathwaysQueryType,
    EnterpriseGetAllSkillPathwaysQueryVariables
  >(EnterpriseGetAllSkillPathwaysQuery, {
    variables: {
      programId: programId || '',
    },
    skip: !programId,
    context: { clientName: 'gatewayGql' },
    errorPolicy: 'all',
    ssr,
  });

  const skillPathways = data?.VerifiedSkills?.getAllSkillPathwaysByProgramId || [];

  return (
    <EnterpriseAllSkillPathwaysContext.Provider
      value={{
        skillPathways,
        loading,
        error,
      }}
    >
      {children}
    </EnterpriseAllSkillPathwaysContext.Provider>
  );
};

export default EnterpriseAllSkillPathwaysDataProvider;
